<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div v-html="html"></div>
</template>

<script setup lang="tsx">
import { defineProps } from 'vue';
import { useTable } from '../../../hooks/use-table';

const props = defineProps<{
  tableHeaderList: any;
  tableDataList: Array<{ [key: string]: Array<string> }>;
}>();

const className = 'task-percent-table-2';
const attrs = `border='0' bordercolor='#C0BEC7'`;
const { createTable } = useTable(props.tableHeaderList, className, attrs);
const html = createTable(props.tableDataList);
</script>
<style lang="scss">
@import '../../../styles/custom-table.scss';
.task-percent-table-2 {
  --header-cell-height: 45px;
  --body-cell-height: 45px;
  &::after {
    @include _custom_table_border;
    width: calc(100% - 4pt);
    height: calc(100% - 4pt);
    border-width: 2pt;
  }
  thead {
    tr {
      th {
        & > div {
          color: #fff;
          &::after {
            @include _custom_table_bg;
            background: var(--theme-color-1);
          }
        }
      }
    }
  }
  tbody {
    tr {
      &:nth-child(even) {
        td {
          & > div {
            &::after {
              @include _custom_table_bg;
            }
          }
        }
      }
    }
  }
}
</style>
